// The wrapped, numbered bottle shown on each round intro (Mel's art,
// 2026-09-23), on a transparent background.
//
// A wine that is served cold gets the version with the "refrigerate" sticker,
// so the GM knows to chill it: whites, rosés and sparkling. Reds, and wines
// with no type recorded, get the plain one.
//
// Missing art falls back rather than breaking: no chilled version yet → the
// plain bottle for that number; no bottle for that number at all → the old
// numbered bottle from the reviewwine bucket.
import round1 from '../assets/rounds/round-1.webp';
import round1Chill from '../assets/rounds/round-1-chill.webp';
import round2 from '../assets/rounds/round-2.webp';
import round3 from '../assets/rounds/round-3.webp';
import round3Chill from '../assets/rounds/round-3-chill.webp';

const PLAIN = { 1: round1, 2: round2, 3: round3 };
const CHILLED = { 1: round1Chill, 3: round3Chill };

const BUCKET = 'https://cmrrsjwbbeurszecszhg.supabase.co/storage/v1/object/public/reviewwine//wine_';

/** True for wines served cold. `type` is wines_v2.type ('Red', 'White', 'Rosé', …). */
export function servedChilled(type) {
  return /white|ros[eé]|sparkl|bubbl|\bmcc\b|champagne|cap classique/i.test(String(type || ''));
}

export function roundBottleSrc(roundNumber, wineType) {
  const n = Number(roundNumber) || 1;
  if (servedChilled(wineType) && CHILLED[n]) return CHILLED[n];
  return PLAIN[n] || `${BUCKET}${n}.png`;
}

/** The bottle a wine-intro step will show, for the curtain to preload.
 *  Mirrors IntroScreen: the round is the step's wine's place in the wine list,
 *  and its type picks the chilled art. */
export function roundBottleForStep(step, wineList, wineTypeMap) {
  const i = Array.isArray(wineList) ? wineList.indexOf(step?.wine) : -1;
  return roundBottleSrc(i >= 0 ? i + 1 : 1, wineTypeMap?.[step?.wine]);
}
